import { defineComponent } from 'vue';
import { prepareComponentOptions, useController } from 'zova';
import { ControllerApp } from '../../component/app/controller.jsx';
export const ZApp = defineComponent(_props => {
  useController(ControllerApp, undefined, undefined);
  return () => {};
}, prepareComponentOptions(ControllerApp.$componentOptions));